// src/api.js
import axios from 'axios';

// Read token from localStorage
const Axios = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Request interceptor to inject token dynamically
Axios.interceptors.request.use(
  (config) => {
    const savedData = localStorage.getItem("storeData");
    const localData = savedData ? JSON.parse(savedData) : null;

    if (localData?.token) {
      config.headers.Authorization = `Bearer ${localData.token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);


// 🔁 Keep your 401 interceptor for logout
Axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("storeData");

      // Optional: redirect to login page
      window.location.href = `${process.env.REACT_APP_BASE_URL}/login`; // or /login based on your routing

      // Reject the promise to propagate error
      return Promise.reject("Session expired. Please log in again.");
    }

    return Promise.reject(error);
  }
);

export default Axios;
